import { CitToken, WusdtLogo } from 'shared';

export interface SaleToken {
  symbol: string;
  decimals: number;
  image: string;
  name: string;
}

export const wusdtToken: SaleToken = {
  symbol: 'wUSDT',
  decimals: 18,
  image: WusdtLogo,
  name: 'wUSDT',
};

export const receiveToken: SaleToken = {
  symbol: 'CIT',
  decimals: 18,
  image: CitToken,
  name: 'CIT',
};
